export default "__VITE_ASSET__Detr3Md7__"